import listService from '../../services/lists.service';

const state ={
    list: [],
    listSubPrefeituras: [],
    listDistritos: [],
    listTipoSexo: [],
    listEstadoCivil: [],
    listNacionalidade: [],
    listPais: [],
    listRaca: [],
    listIdentidadeSexual: [],
    listFormasCuidado: [],
    listTipologiaServicoReordenamento: [],
    listTipologiaServicoAcolhimento: [],
    listTipologiaServicoAcolhimentoSigiloso: [],    
    listServico: [],
    listMotivoProcura: [],
    listMotivoReordenamento: [],
    listOrigemProcura: [],
    listTipoLogradouro: [],
    listDeficiencia: [],
    listSituacaoSolicitacao: [],
    getStreetByCEP: '',
    getListPregnantEnable: [],
    listGrauDependencia: [],
    listVIJ: [],
    listMotivosCancelamento:[]
};

const getters ={
    list: state => {
        return state.list;
    },
    listSubPrefeituras: state => {
        return state.listSubPrefeituras;
    },
    listDistritos: state => {
        return state.listDistritos;
    },
    listTipoSexo: state => {
        return state.listTipoSexo;
    },
    listEstadoCivil: state => {
        return state.listEstadoCivil;
    },
    listNacionalidade: state => {
        return state.listNacionalidade;
    },
    listPais: state => {
        return state.listPais;
    },
    listRaca: state => {
        return state.listRaca;
    },
    listIdentidadeSexual: state => {
        return state.listIdentidadeSexual;
    },
    listFormasCuidado: state => {
        return state.listFormasCuidado;
    },
    listTipologiaServicoReordenamento: state => {
        return state.listTipologiaServicoReordenamento;
    },
    listTipologiaServicoAcolhimento: state => {
        return state.listTipologiaServicoAcolhimento;
    },
    listTipologiaServicoAcolhimentoSigiloso: state => {
        return state.listTipologiaServicoAcolhimentoSigiloso;
    },
    listServico: state => {
        return state.listServico;
    },
    listMotivoProcura: state => {
        return state.listMotivoProcura;
    },
    listMotivoReordenamento: state => {
        return state.listMotivoReordenamento;
    },
    listOrigemProcura: state => {
        return state.listOrigemProcura;
    },
    listTipoLogradouro: state => {
        return state.listTipoLogradouro;
    },
    listDeficiencia: state => {
        return state.listDeficiencia;
    },    
    listSituacaoSolicitacao: state => {
        return state.listSituacaoSolicitacao;
    },
    getStreetByCEP: state => {
        return state.getStreetByCEP;
    },
    getListPregnantEnable: state => {
        return state.getListPregnantEnable;
    },
    listGrauDependencia: state => {
        return state.listGrauDependencia;
    },
    listVIJ: state => {
        return state.listVIJ;
    },
    listMotivosCancelamento: state =>{
        return state.listMotivosCancelamento;
    }
};

const mutations = {
    list: (state, payload) => {
        state.list = payload.data;
    },
    listSubPrefeituras: (state, payload) => {
        state.listSubPrefeituras = payload.data;
    },
    listDistritos: (state, payload) => {
        state.listDistritos = payload.data;
    },
    listTipoSexo: (state, payload) => {
        //removendo a lista o item Não Informado
        let listaFiltrada = payload.data.filter(function(f) {return f.DescricaoTipoSexo != "Não Informado"});
        state.listTipoSexo = listaFiltrada;
    },
    listEstadoCivil: (state, payload) => {
        state.listEstadoCivil = payload.data;
    },
    listNacionalidade: (state, payload) => {
        let listaFiltrada = payload.data.filter(function(f) {return f.Descricao != "Não Informada"});
        state.listNacionalidade = listaFiltrada;
    },
    listPais: (state, payload) => {
        state.listPais = payload.data;
    },
    listRaca: (state, payload) => {
        //removendo a lista o item Não Informada
        let listaFiltrada = payload.data.filter(function(f) {return f.DescricaoRaca != "Não Informada"});
        state.listRaca = listaFiltrada;
    },
    listIdentidadeSexual: (state, payload) => {
        state.listIdentidadeSexual = payload.data;
    },
    listFormasCuidado: (state, payload) => {
        state.listFormasCuidado = payload.data;
    },
    listTipologiaServicoReordenamento: (state, payload) => {
        state.listTipologiaServicoReordenamento = payload.data;
    },
    listTipologiaServicoAcolhimento: (state, payload) => {
        state.listTipologiaServicoAcolhimento = payload.data;
    },
    listTipologiaServicoAcolhimentoSigiloso: (state, payload) => {
        state.listTipologiaServicoAcolhimentoSigiloso = payload.data;
    },
    listServico: (state, payload) => {
        state.listServico = payload.data;
    },
    listMotivoProcura: (state, payload) => {
        state.listMotivoProcura = payload.data;
    },
    listMotivoReordenamento: (state, payload) => {
        state.listMotivoReordenamento = payload.data;
    },
    listOrigemProcura: (state, payload) => {
        state.listOrigemProcura = payload.data;
    },
    listTipoLogradouro: (state, payload) => {
        state.listTipoLogradouro = payload.data;
    },
    listDeficiencia: (state, payload) => {
        state.listDeficiencia = payload.data;
    },
    listSituacaoSolicitacao: (state, payload) => {
        state.listSituacaoSolicitacao = payload.data;
    },
    getStreetByCEP: (state, payload) => {
        state.getStreetByCEP = payload.data;
    },
    getListPregnantEnable: (state, payload) => {
        state.getListPregnantEnable = payload.data;
    },
    listGrauDependencia: (state, payload) => {
        state.listGrauDependencia = payload.data;
    },
    listVIJ: (state, payload) => {
        state.listVIJ = payload.data;
    },
    listMotivosCancelamento: (state, payload) => {
        state.listMotivosCancelamento = payload.data;
    }
};

const actions = {
    listSubPrefeituras: async({commit}) => {
        try {
            const response = await listService.listAllSubPrefeitura();
            if (response.data != null) {
                commit('listSubPrefeituras', response);   
             }else{
                commit('listSubPrefeituras', []);
             }
        } catch (error) {
            commit('listSubPrefeituras', []);
            throw error;
        }
    },

    listDistritos: async({commit}, id) => {
        try {
            const response = await listService.listDistritos(id);
            if (response.data != null) {
                commit('list', response);   
             }else{
                commit('list', []);
             }
        } catch (error) {
            commit('list', []);
            throw error;
        }
    },

    listTipoSexo: async({commit}) => {
        try {
            const response = await listService.listTipoSexo();
            if (response.data != null) {
                commit('listTipoSexo', response);   
             }else{
                commit('listTipoSexo', []);
             }
        } catch (error) {
            commit('listTipoSexo', []);
            throw error;
        }
    },

    listEstadoCivil: async({commit}) => {
        try {
            const response = await listService.listEstadoCivil();
            if (response.data != null) {
                commit('listEstadoCivil', response);   
             }else{
                commit('listEstadoCivil', []);
             }
        } catch (error) {
            commit('listEstadoCivil', []);
            throw error;
        }
    },

    listNacionalidade: async({commit}) => {
        try {
            const response = await listService.listNacionalidade();
            if (response.data != null) {
                commit('listNacionalidade', response);   
             }else{
                commit('listNacionalidade', []);
             }
        } catch (error) {
            commit('listNacionalidade', []);
            throw error;
        }
    },

    listPais: async({commit}) => {
        try {
            const response = await listService.listPais();
            if (response.data != null) {
                commit('listPais', response);   
             }else{
                commit('listPais', []);
             }
        } catch (error) {
            commit('listPais', []);
            throw error;
        }
    },

    listCidadesPorUf: async({commit}, siglaUf) => {
        try {
            const response = await listService.listCidadePorUF(siglaUf);
            if (response.data != null) {
                commit('list', response);   
             }else{
                commit('list', []);
             }
        } catch (error) {
            commit('list', []);
            throw error;
        }
    },

    listRaca: async({commit}) => {
        try {
            const response = await listService.listRaca();
            
            if (response.data != null) {
                commit('listRaca', response);   
             }else{
                commit('listRaca', []);
             }
        } catch (error) {
            commit('list', []);
            throw error;
        }
    },

    listIdentidadeSexual: async({commit}) => {
        try {
            const response = await listService.listIdentidadeSexual();
            if (response.data != null) {
                commit('listIdentidadeSexual', response);   
             }else{
                commit('listIdentidadeSexual', []);
             }
        } catch (error) {
            commit('listIdentidadeSexual', []);
            throw error;
        }
    },

    listFormasCuidado: async({commit}) => {
        try {
            const response = await listService.listFormasCuidado();
            if (response.data != null) {
                commit('listFormasCuidado', response);   
             }else{
                commit('listFormasCuidado', []);
             }
        } catch (error) {
            commit('listFormasCuidado', []);
            throw error;
        }
    },

    listTipologiaServicoReordenamento: async({commit}, idOrigemProcura) => {
        try {
            const response = await listService.listTipologiaServicoReordenamento(idOrigemProcura);
            if (response.data != null) {
                commit('listTipologiaServicoReordenamento', response);   
             }else{
                commit('listTipologiaServicoReordenamento', []);
             }
        } catch (error) {
            commit('listTipologiaServicoReordenamento', []);
            throw error;
        }
    },

    listTipologiaServicoAcolhimento: async({commit}, idOrigemProcura) => {
        try {
            const response = await listService.listTipologiaServicoAcolhimento(idOrigemProcura);
            if (response.data != null) {
                commit('listTipologiaServicoAcolhimento', response);   
             }else{
                commit('listTipologiaServicoAcolhimento', []);
             }
        } catch (error) {
            commit('listTipologiaServicoAcolhimento', []);
            throw error;
        }
    },

    listTipologiaServicoAcolhimentoSigiloso: async({commit}) => {
        try {
            const response = await listService.listTipologiaServicoAcolhimentoSigiloso();
            if (response.data != null) {
                commit('listTipologiaServicoAcolhimentoSigiloso', response);   
             }else{
                commit('listTipologiaServicoAcolhimentoSigiloso', []);
             }
        } catch (error) {
            commit('listTipologiaServicoAcolhimentoSigiloso', []);
            throw error;
        }
    },

    listServico: async({commit}) => {
        try {
            const response = await listService.listServico();
            if (response.data != null) {
                commit('listServico', response);   
             }else{
                commit('listServico', []);
             }
        } catch (error) {
            commit('listServico', []);
            throw error;
        }
    },

    listMotivoProcura: async ({ commit }) => {
        try {
            const response = await listService.listMotivoProcura();
            if (response.data != null) {
                commit('listMotivoProcura', response);   
             }else{
                commit('listMotivoProcura', []);
             }
        } catch (error) {
            commit('listMotivoProcura', []);
            throw error;
        }
    },
    listMotivoReordenamento: async ({ commit }) => {
        try {
            const response = await listService.listMotivoReordenamento();
            if (response.data != null) {
                commit('listMotivoReordenamento', response);   
             }else{
                commit('listMotivoReordenamento', []);
             }
        } catch (error) {
            commit('listMotivoReordenamento', []);
            throw error;
        }
    },

    listOrgaoSolicitante: async({commit},idOrigemProcura) => {
        try {
            const response = await listService.listOrgaoSolicitante(idOrigemProcura);
            if (response.data != null) {
                commit('list', response);   
             }else{
                commit('list', []);
             }
        } catch (error) {
            commit('list', []);
            throw error;
        }
    },

    listOrigemProcura: async({commit}) => {
        try {
            const response = await listService.listOrigemProcura();
            if (response.data !== null) {
                commit('listOrigemProcura', response);
             }else{
                commit('listOrigemProcura', []);
             }
        } catch (error) {
            commit('listOrigemProcura', []);
            throw error;
        }
    },

    listTipoLogradouro: async({commit}) => {
        try {
            const response = await listService.listTipoLogradouro();
            if (response.data != null) {
                commit('listTipoLogradouro', response);   
             }else{
                commit('listTipoLogradouro', []);
             }
        } catch (error) {
            commit('listTipoLogradouro', []);
            throw error;
        }
    },

    listDeficiencia: async({commit}) => {
        try {
            const response = await listService.listDeficiencia();
            if (response.data != null) {
                commit('listDeficiencia', response);   
             }else{
                commit('listDeficiencia', []);
             }
        } catch (error) {
            commit('listDeficiencia', []);
            throw error;
        }
    },
    listSituacaoSolicitacao: async({commit}) => {
        try {
            const response = await listService.listSituacoesSolicitacao();
            if (response.data != null) {
                commit('listSituacaoSolicitacao', response);   
             }else{
                commit('listSituacaoSolicitacao', []);
             }
        } catch (error) {
            commit('listSituacaoSolicitacao', []);
            throw error;
        }
    },
    
    getStreetByCEP: async({commit}, value) => {
        try {
            const response = await listService.getStreetByCEP(value);
            if (response.data != null) {
                commit('getStreetByCEP', response);   
             }else{
                commit('getStreetByCEP', '');
             }
        } catch (error) {
            commit('getStreetByCEP', '');
            throw error;
        }
    },
    getListPregnantEnable: async({commit}, value) => {
        try {
            const response = await listService.getListPregnantEnable(value);
            if (response.data != null) {
                commit('getListPregnantEnable', response);   
             }else{
                commit('getListPregnantEnable', '');
             }
        } catch (error) {
            commit('getListPregnantEnable', '');
            throw error;
        }
    },
    listGrauDependencia: async({commit}) => {
        try {
            const response = await listService.listGrauDependencia();
            if (response.data != null) {
                commit('listGrauDependencia', response);   
             }else{
                commit('listGrauDependencia', []);
             }
        } catch (error) {
            commit('listGrauDependencia', []);
            throw error;
        }
    },
    
    listVIJ: async({commit}) => {
        try {
            const response = await listService.listVIJ();
            if (response.data != null) {
                commit('listVIJ', response);   
             }else{
                commit('listVIJ', []);
             }
        } catch (error) {
            commit('listVIJ', []);
            throw error;
        }
    },

    listMotivosCancelamento: async({commit}) => {
        try {
            const response = await listService.listMotivosCancelamento();
            
            if (response.data != null) {
                commit('listMotivosCancelamento', response);   
             }else{
                commit('listMotivosCancelamento', []);
             }
        } catch (error) {
            commit('listMotivosCancelamento', []);
            throw error;
        }
    },

};


export default {
    namespaced:true,
    state,
    getters,
    mutations,
    actions
};
